import React, { useEffect, useState, useCallback } from 'react';
import { formatCurrency } from '../../tools/tool';
import { adminServices } from '../../services/AdminServices';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
const TotalCashReleaseCard = ({
  dateRange
}) => {
  const navigate = useNavigate();
  const [totalCashRelease, setTotalCashRelease] = useState(0);
  const [pendingAmount, setPendingAmount] = useState(0);
  const [completedAmount, setCompletedAmount] = useState(0);
  const getCashReleaseData = useCallback(async () => {
    try {
      let storedProcedureName = 'cash_out_request';
      let params = {};
      if (dateRange.dateFrom && dateRange.dateTo) {
        params = {
          dateFrom: dateRange.dateFrom,
          dateTo: dateRange.dateTo
        };
        storedProcedureName = 'cash_out_requests_range';
      } else {
        params = {};
      }
      const response = await adminServices.storeProcedure2(storedProcedureName, params);
      if (response.status === 200 && response.data && response.data.length > 0) {
        const completed = response.data.filter(item => item.current_status === "Completed");
        const pending = response.data.filter(item => item.current_status !== "Completed");
        const completedTotal = completed.reduce((total, item) => total + Math.abs(item.amount || 0), 0);
        const pendingTotal = pending.reduce((total, item) => total + Math.abs(item.amount || 0), 0);
        const grandTotal = completedTotal + pendingTotal;
        setCompletedAmount(completedTotal);
        setPendingAmount(pendingTotal);
        setTotalCashRelease(grandTotal);
      } else {
        setTotalCashRelease(0);
        setPendingAmount(0);
        setCompletedAmount(0);
      }
    } catch (error) {
      if (error.status === 401) {
        navigate('/');
      }
      if (error.status === 429) {
        toast.error('Too many requests. Data will retry in 1 minute.');
        setTimeout(async () => {
          await getCashReleaseData();
        }, 60000);
      }
      setTotalCashRelease(0);
      setPendingAmount(0);
      setCompletedAmount(0);
    }
  }, [navigate, dateRange]);
  useEffect(() => {
    getCashReleaseData();
  }, [getCashReleaseData, dateRange]);
  return <div className="card" style={{
    width: '100%',
    marginBottom: '20px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  }}>
        <div className="card-header" style={{
      backgroundColor: '#f8f9fa',
      borderBottom: '1px solid #e0e0e0',
      padding: '15px',
      textAlign: 'center'
    }}>
          <h5 style={{
        margin: 0,
        color: '#333',
        fontWeight: 'bold'
      }}>TOTAL CASH SURRENDER TO PDL</h5>
        </div>
      <div className="card-body" style={{
      padding: '20px'
    }}>
        <div style={{
        textAlign: 'center',
        marginBottom: '20px'
      }}>
          <h2 style={{
          fontSize: '2rem',
          fontWeight: 'bold',
          color: '#333',
          margin: 0
        }}>
          {formatCurrency(totalCashRelease || 0)}
          </h2>
        </div>
        
        <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: '15px',
        marginBottom: '15px'
      }}>
          <div style={{
          flex: 1,
          textAlign: 'center'
        }}>
            <h6 style={{
            color: '#666',
            marginBottom: '5px'
          }}>Pending</h6>
            <p style={{
            fontSize: '1.1rem',
            fontWeight: 'bold',
            color: '#ffc107',
            margin: '0 0 10px 0'
          }}>
            {formatCurrency(pendingAmount || 0)}
            </p>
          </div>
          
          <div style={{
          flex: 1,
          textAlign: 'center'
        }}>
            <h6 style={{
            color: '#666',
            marginBottom: '5px'
          }}>Completed</h6>
            <p style={{
            fontSize: '1.1rem',
            fontWeight: 'bold',
            color: '#28a745',
            margin: '0 0 10px 0'
          }}>
            {formatCurrency(completedAmount || 0)}
            </p>
          </div>
        </div>
        
      </div>
    </div>;
};
export default TotalCashReleaseCard;